(function () {
  'use strict';

  var HOST_TIMEOUT_MS = 6000;

  function getAppConfig() {
    var cfg = (window.algoliaShopify && window.algoliaShopify.config) || {};
    return {
      appId: cfg.app_id || cfg.applicationId || cfg.application_id || '',
      apiKey: cfg.search_api_key || cfg.searchApiKey || cfg.api_key || '',
      indexName:
        cfg.products_index ||
        (cfg.index_prefix ? cfg.index_prefix + 'products' : '') ||
        (cfg.index_name ? String(cfg.index_name).replace(/_(products|collections|pages|articles)$/, '') + '_products' : '')
    };
  }

  function fetchWithTimeout(url, options) {
    if (typeof AbortController !== 'function') {
      return fetch(url, options);
    }
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, HOST_TIMEOUT_MS);
    options = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, options).finally(function () { clearTimeout(timer); });
  }

  function requestRecommendations(appId, apiKey, body) {
    var qs =
      '?x-algolia-agent=' + encodeURIComponent('Kingsley Theme Recommend') +
      '&x-algolia-application-id=' + encodeURIComponent(appId) +
      '&x-algolia-api-key=' + encodeURIComponent(apiKey);
    var hosts = [
      'https://' + appId.toLowerCase() + '-dsn.algolia.net',
      'https://' + appId.toLowerCase() + '-1.algolianet.com',
      'https://' + appId.toLowerCase() + '-2.algolianet.com'
    ];

    function tryHost(i) {
      if (i >= hosts.length) return Promise.reject(new Error('All Algolia hosts failed'));
      return fetchWithTimeout(hosts[i] + '/1/indexes/*/recommendations' + qs, {
        method: 'POST',
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .catch(function () {
          return tryHost(i + 1);
        });
    }

    return tryHost(0);
  }

  function formatPrice(value) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(value);
    } catch (e) {
      return '$' + Number(value).toFixed(2);
    }
  }

  function cardImageUrl(hit) {
    var img = hit.product_image || hit.image || (hit.images && hit.images[0]) || '';
    if (!img) {
      return (window.themeSettings && window.themeSettings.placeholderImageUrl) ||
        'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
    }
    if (img.indexOf('//') === 0) img = 'https:' + img;
    return img;
  }

  function dedupeHits(hits, max) {
    var seen = {};
    var out = [];
    for (var i = 0; i < hits.length; i++) {
      var h = hits[i];
      if (!h || !h.handle || !h.objectID || seen[h.objectID]) continue;
      seen[h.objectID] = true;
      out.push(h);
      if (out.length >= max) break;
    }
    return out;
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function visuallyHidden(text) {
    var span = el('span', 'visually-hidden visually-hidden--inline');
    span.textContent = text;
    return span;
  }

  function buildPrice(hit) {
    var price = Number(hit.price);
    var compare = Number(hit.compare_at_price);
    var onSale = !isNaN(compare) && compare > price;

    var wrap = el('div', onSale ? 'price price--on-sale' : 'price');
    var container = el('div', 'price__container');

    if (onSale) {
      var sale = el('div', 'price__sale');
      sale.appendChild(visuallyHidden('Regular price'));
      var compareWrap = el('span');
      var compareEl = el('s', 'price-item price-item--regular');
      compareEl.textContent = formatPrice(compare);
      compareWrap.appendChild(compareEl);
      sale.appendChild(compareWrap);
      sale.appendChild(visuallyHidden('Sale price'));
      var saleItem = el('span', 'price-item price-item--sale price-item--last');
      saleItem.textContent = formatPrice(price);
      sale.appendChild(saleItem);
      container.appendChild(sale);
    } else {
      var regular = el('div', 'price__regular');
      regular.appendChild(visuallyHidden('Regular price'));
      var regularItem = el('span', 'price-item price-item--regular');
      regularItem.textContent = formatPrice(price);
      regular.appendChild(regularItem);
      container.appendChild(regular);
    }

    wrap.appendChild(container);
    return wrap;
  }

  function buildCard(hit, index, total) {
    var li = el('li', 'uic-HorizontalSlider-item');
    li.setAttribute('aria-roledescription', 'slide');
    li.setAttribute('aria-label', (index + 1) + ' of ' + total);

    var vid = String(hit.objectID || '');
    var title = hit.title || hit.name || '';
    var productUrl = '/products/' + hit.handle + (vid ? '?variant=' + vid : '');

    var wrapper = el('div', 'card-wrapper product-card-wrapper underline-links-hover');
    wrapper.id = vid;

    var card = el('div', 'card card--standard card--media');
    card.style.setProperty('--ratio-percent', '100%');

    var inner = el('div', 'card__inner gradient ratio');
    inner.id = 'Card--' + vid;
    inner.style.setProperty('--ratio-percent', '100%');

    var mediaWrap = el('div', 'card__media');
    var media = el('div', 'media media--transparent media--hover-effect');
    var imgUrl = cardImageUrl(hit);
    if (imgUrl) {
      var img = el('img', 'motion-reduce');
      img.src = imgUrl;
      img.alt = title;
      img.loading = 'lazy';
      img.setAttribute('sizes', '(max-width: 200px) 100vw, 200px');
      media.appendChild(img);
    }
    mediaWrap.appendChild(media);
    inner.appendChild(mediaWrap);

    var innerContent = el('div', 'card__content');
    var innerInfo = el('div', 'card__information');
    var innerHeading = el('h3', 'card__heading');
    var innerLink = el('a', 'full-unstyled-link');
    innerLink.id = 'StandardCardNoMediaLink--' + vid;
    innerLink.setAttribute('aria-labelledby', 'StandardCardNoMediaLink--' + vid + ' NoMediaStandardBadge--' + vid);
    innerLink.textContent = title;
    innerHeading.appendChild(innerLink);
    innerInfo.appendChild(innerHeading);
    innerContent.appendChild(innerInfo);
    innerContent.appendChild(el('div', 'card__badge bottom left'));
    inner.appendChild(innerContent);
    card.appendChild(inner);

    var content = el('div', 'card__content');
    var info = el('div', 'card__information');

    var infoData = el('div', 'card-information-data');
    var heading = el('h3', 'card__heading h5');
    heading.id = 'title--' + vid;
    var link = el('a', 'full-unstyled-link');
    link.href = productUrl;
    link.id = 'CardLink--' + vid;
    link.setAttribute('aria-labelledby', 'CardLink--' + vid + ' Badge--' + vid);
    link.textContent = title;
    heading.appendChild(link);
    infoData.appendChild(heading);
    info.appendChild(infoData);

    var infoBottom = el('div', 'card-information');
    infoBottom.appendChild(buildPrice(hit));
    info.appendChild(infoBottom);

    content.appendChild(info);
    content.appendChild(el('div', 'card__badge bottom left'));
    card.appendChild(content);

    wrapper.appendChild(card);
    li.appendChild(wrapper);
    return li;
  }

  function bindNav(root) {
    var list = root.querySelector('.uic-HorizontalSlider-list');
    var prev = root.querySelector('.uic-HorizontalSlider-navigation--previous');
    var next = root.querySelector('.uic-HorizontalSlider-navigation--next');
    if (!list || !prev || !next) return;

    function step() {
      var item = list.querySelector('.uic-HorizontalSlider-item');
      return item ? item.getBoundingClientRect().width + 16 : list.clientWidth;
    }

    function sync() {
      var overflowing = list.scrollWidth > list.clientWidth + 4;
      var maxScroll = list.scrollWidth - list.clientWidth - 2;
      prev.hidden = !overflowing || list.scrollLeft <= 2;
      next.hidden = !overflowing || list.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      list.scrollBy({ left: -step() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      list.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function fetchCard(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=algolia-recommend-card')
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrapper = doc.querySelector('.shopify-section');
        var markup = wrapper ? wrapper.innerHTML.trim() : '';
        return markup || null;
      })
      .catch(function () {
        return null;
      });
  }

  function renderTrending(section, items, min) {
    var tpl = section.querySelector('template[data-algolia-trending-slider]');
    if (!tpl) return;

    Promise.all(items.map(function (hit) { return fetchCard(hit.handle); })).then(function (cards) {
      cards = cards.filter(Boolean);
      if (cards.length < min) return;

      var slider = tpl.content.cloneNode(true);
      var list = slider.querySelector('ul[id^="Slider-"]');
      var sectionId = list.getAttribute('data-id');
      cards.forEach(function (markup, index) {
        var li = document.createElement('li');
        li.id = 'Slide-' + sectionId + '-' + (index + 1);
        li.className = 'grid__item slider__slide';
        li.innerHTML = markup;
        list.appendChild(li);
      });

      section.removeAttribute('hidden');
      tpl.parentNode.replaceChild(slider, tpl);
      var sliderComponent = section.querySelector('slider-component');
      if (sliderComponent && typeof window.initFeaturedCollectionSlider === 'function') {
        window.initFeaturedCollectionSlider(sliderComponent);
      }
      if (typeof window._triggerEquateRescan === 'function') {
        window._triggerEquateRescan();
      }
    });
  }

  function initTrending(section) {
    if (section.getAttribute('data-loaded') === 'true') return;
    section.setAttribute('data-loaded', 'true');

    var auto = getAppConfig();
    var appId = section.getAttribute('data-app-id') || auto.appId;
    var apiKey = section.getAttribute('data-api-key') || auto.apiKey;
    var indexName = section.getAttribute('data-index-name') || auto.indexName;
    if (!appId || !apiKey || !indexName) return;

    var max = parseInt(section.getAttribute('data-max'), 10) || 12;
    var min = parseInt(section.getAttribute('data-min'), 10) || 1;

    requestRecommendations(appId, apiKey, {
      requests: [{
        model: 'trending-items',
        indexName: indexName,
        maxRecommendations: max,
        threshold: 0,
        queryParameters: { clickAnalytics: true }
      }]
    })
      .then(function (data) {
        var hits = (data && data.results && data.results[0] && data.results[0].hits) || [];
        var seen = {};
        var items = dedupeHits(hits, hits.length).filter(function (h) {
          if (seen[h.handle]) return false;
          seen[h.handle] = true;
          return true;
        }).slice(0, max);
        if (items.length < min) return;
        renderTrending(section, items, min);
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-algolia-trending]').forEach(initTrending);

    var root = document.getElementById('alg-recommend-wrapper-theme');
    if (!root || root.getAttribute('data-loaded') === 'true') return;
    root.setAttribute('data-loaded', 'true');

    var objectID = root.getAttribute('data-object-id');
    if (!objectID) return;

    var auto = getAppConfig();
    var appId = root.getAttribute('data-app-id') || auto.appId;
    var apiKey = root.getAttribute('data-api-key') || auto.apiKey;
    var indexName = root.getAttribute('data-index-name') || auto.indexName;
    if (!appId || !apiKey || !indexName) return;

    var model = root.getAttribute('data-model') || 'bought-together';
    var max = parseInt(root.getAttribute('data-max'), 10) || 12;
    var min = parseInt(root.getAttribute('data-min'), 10) || 1;

    var request = {
      model: model,
      indexName: indexName,
      maxRecommendations: max,
      objectID: objectID,
      threshold: 0,
      queryParameters: { clickAnalytics: true }
    };

    requestRecommendations(appId, apiKey, { requests: [request] })
      .then(function (data) {
        var hits = (data && data.results && data.results[0] && data.results[0].hits) || [];
        var items = dedupeHits(hits, max);
        if (items.length < min) return;

        var list = root.querySelector('.uic-HorizontalSlider-list');
        if (!list) return;
        var frag = document.createDocumentFragment();
        items.forEach(function (hit, index) {
          frag.appendChild(buildCard(hit, index, items.length));
        });
        list.appendChild(frag);
        root.removeAttribute('hidden');
        bindNav(root);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
